__turbopack_context__.v({
  "menuWrapper": "qAMGbW_menuWrapper",
});
